<template>
    <div class="variant-metadata-wrapper">
        <div class="variant-metadata">
            <ul class="metadata-list">
                <li
                    v-for="(metadata, index) in variant.metadata"
                    :key="index"
                    class="metadata-item"
                >
                    <div class="metadata-name">{{ metadata.name }}:</div>
                    <div class="metadata-value">
                        {{ metadata.value }}
                        <span class="info-icon-wrapper">
                            <span class="fa-stack fa-1x">
                                <i class="fa fa-circle fa-stack-2x"></i>
                                <i
                                    class="fa fa-info fa-stack-1x fa-inverse"
                                ></i>
                            </span>
                            <span class="variant-metadata-info">{{
                                metadata.description
                            }}</span>
                        </span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "seat-picker-metadata-info",
    props: {
        variant: {
            type: Object,
            required: true,
        },
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
@import "../../../sass/base/_variables.scss";
@import "../../../sass/mixins/_breakpoint.scss";

.variant-metadata-wrapper {
    display: inline-block;
    text-align: left;

    .metadata-item {
        .metadata-name {
            font-weight: bold;
        }

        .variant-metadata-info {
            position: absolute;
            z-index: 9999999;
            display: none;
            background-color: #fff;
            padding: 20px;
            border-radius: 10px;
            max-width: 400px;
            box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
            white-space: pre-wrap;
        }

        .info-icon-wrapper {
            &:hover,
            &:active {
                .variant-metadata-info {
                    display: block;
                }
            }
        }
    }
}
@include mq(max-width, $mq-mob) {
    .variant-metadata-wrapper {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/SeatPicker/metadata-info.vue